import { setTags, setUser } from '@repo/monitoring';
import { useRouteContext } from '@tanstack/react-router';
import { useEffect } from 'react';

const useMonitoringIdentity = () => {
  const { user, isPractitioner, isImpersonating, impersonationId } =
    useRouteContext({ from: '__root__' });
  const userId = user?.id;
  const practitionerId = isPractitioner
    ? (impersonationId ?? userId)
    : undefined;

  useEffect(() => {
    setUser(userId ? { id: userId } : null);
    setTags({
      practitioner_id: practitionerId,
      impersonated: isImpersonating ? true : undefined,
    });
  }, [userId, practitionerId, isImpersonating]);
};

export default useMonitoringIdentity;
